// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-pagination .pagination{border-top:1px solid #dedede;padding:15px 0 0;text-align:center}.common-pagination .pagination a{background:#fff;color:#737373;padding:5px 9px;transition:background .3s ease-out}.common-pagination .pagination .gap{color:#b8b8b8}.common-pagination .pagination .active{background:#fba617;border-radius:3px;color:#fff;padding:5px 8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
